import { ChangeEvent } from "react";
import { Option } from "../../../../types/General/Option";
import { AuthUser } from "../../../../types/User/AuthUser";

interface IndicatorSelectComponent {
  fieldNameObject: string;
  options: Option[];
  fieldName: string;
  width: string;
  control: any;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  isDisabled?: boolean;
  isLoaded: boolean;
  defaultValue?: string | number | null;
}

export const indicatorManagementTableSelectFilterData = (
  indicatorOptions: Option[],
  partnerOptions: Option[],
  levelOptions: Option[],
  stateOptions: Option[],
  frequencyOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedFilter: (filterName: string, value: string | null) => void,
  indicatorLoaded: boolean,
  partnerLoaded: boolean,
  levelLoaded: boolean,
  stateLoaded: boolean,
  frequencyLoaded: boolean,
  user: AuthUser,
): IndicatorSelectComponent[] => {
  const handleSelectChange =
    (filterName: string) => (e: ChangeEvent<HTMLSelectElement>) => {
      const selectedId = e.target.value;
      const selectedText = e.target.selectedOptions[0].text;
      setSelectedFilter(filterName, selectedText);
      setFilter(filterName, selectedId);
    };

  return [
    {
      fieldNameObject: "IndicatorId",
      options: indicatorOptions,
      fieldName: "Indicador",
      control: control,
      width: "230px",
      onChange: handleSelectChange("IndicatorId"),
      isLoaded: indicatorLoaded,
    },
    {
      fieldNameObject: "PartnerId",
      options: partnerOptions,
      fieldName: "Parceiro",
      control: control,
      width: "230px",
      onChange: handleSelectChange("PartnerId"),
      isLoaded: partnerLoaded,
      isDisabled:
        user?.role?.level !== undefined &&
        user?.role.level.id === 2 &&
        user?.partner !== undefined,
      defaultValue:
        user?.role?.level !== undefined &&
        user?.role.level.id === 2 &&
        user?.partner !== undefined
          ? user.partner.id
          : "",
    },
    {
      fieldNameObject: "LevelId",
      options: levelOptions,
      fieldName: "Nível",
      control: control,
      width: "230px",
      onChange: handleSelectChange("LevelId"),
      isLoaded: levelLoaded,
    },
    {
      fieldNameObject: "StateId",
      options: stateOptions,
      fieldName: "Estado",
      control: control,
      width: "230px",
      onChange: handleSelectChange("StateId"),
      isLoaded: stateLoaded,
    },
    {
      fieldNameObject: "FrequencyId",
      options: frequencyOptions,
      fieldName: "Frequência de recolha",
      control: control,
      width: "230px",
      onChange: handleSelectChange("FrequencyId"),
      isLoaded: frequencyLoaded,
    },
  ];
};
